export default {"src":"/_next/static/media/transit-car.351cceaa.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};